exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sweep-code-dialog[data-v-378e3914]{padding:0 20px 10px}.sweep-code-dialog .title[data-v-378e3914]{font-size:18px;color:#333;text-align:center;margin-bottom:18px}.sweep-code-dialog .tips[data-v-378e3914]{font-size:14px;color:#999;text-align:center;margin-top:20px}", ""]);

// exports
